import React, { createRef, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as actions from '../store/sm';
import proxyVideo from '../proxyVideo';
import { headerHeight, transparentHeader } from '../config';

function PersonaVideo({ className }) {
  const dispatch = useDispatch();
  const setVideoDimensions = (videoWidth, videoHeight) => dispatch(
    actions.setVideoDimensions({ videoWidth, videoHeight }),
  );
  const { loading, connected } = useSelector(({ sm }) => ({ ...sm }));
  const videoRef = createRef();
  const containerRef = createRef();
  const [videoDisplayed, setVideoDisplayed] = useState(false);
  const [height, setHeight] = useState('100vh');
  const [muted, setMuted] = useState(true);

  const handleResize = () => {
    if (containerRef.current) {
      const videoWidth = containerRef.current.clientWidth;
      const videoHeight = containerRef.current.clientHeight;
      setVideoDimensions(videoWidth, videoHeight);
      setHeight(`${videoHeight}`);
    }
  };

  const handleUserInput = () => {
    setMuted(false);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    if (connected && !videoDisplayed) {
      videoRef.current.srcObject = proxyVideo.srcObject;
      setVideoDisplayed(true);
    }

    // Add event listeners to detect user input (e.g., click or key press)
    window.addEventListener('click', handleUserInput);
    window.addEventListener('keydown', handleUserInput);

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('click', handleUserInput);
      window.removeEventListener('keydown', handleUserInput);
    };
  }, [connected, videoDisplayed]);

  return (
    <div ref={containerRef} className={className} style={{ height }}>
      {
        connected && !loading
          ? (
            <video
              ref={videoRef}
              playsInline
              className="persona-video"
              id="personavideo"
              data-sm-video
              muted={muted}
              autoPlay={connected && videoDisplayed}
            >
              <track kind="captions" />
            </video>
          )
          : null
      }
      {
        loading
          ? (
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          )
          : null
      }
      {
        connected === false && loading === false ? 'disconnected' : ''
      }
    </div>
  );
}

PersonaVideo.propTypes = {
  className: PropTypes.string.isRequired,
};

export default styled(PersonaVideo)`
  width: 100vw;
  position: fixed;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${transparentHeader ? '' : headerHeight};
  .persona-video {
    width: 100%;
    height: 100%;
  }
`;
